import React, { useCallback, useEffect, useState } from "react";

import { useAppContext } from "../../config/AppContext";

import { useSnackbar } from "notistack";
import { doc } from "firebase/firestore";
import { Spin } from "antd";

import PrimaryButton from "../../buttons/PrimaryButton";

import Space from "../../layout/Space";
import { Attestation, Org, User, Xml } from "../../types/basicTypes";
import type { File, MaitreOeuvre } from "../../types/basicTypes";
import {
  transformFilesToTable,
  transformXmlsToTable,
} from "../../models/OrgFunctions";
import Icon1 from "../../assets/icons/Icon";
import TabGPT from "../../tabs/TabGPT";
import DataGridGPT2 from "../../tables/DataGridGPT2";
import SearchBarFolders from "../../textfields/SearchBarFolders";
import BasicSearchBar from "../../textfields/BasicSearchBar";
import {
  getDocDataById,
  getFlutterTime,
  getLocalDateFromFlutter,
  getLocalFromFlutterString,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions";
import createDocApi from "../../api/database/createDocApi";
import SmallSpinner from "../../loading/SmallSpinner";
import { generateID, InfosBlockModify } from "./helpers/generalHelpers";
import NewAttestationModal from "./init/NewAttestationModal";
import ModalRight from "../../modals/ModalRight";
import SecondaryButton from "../../buttons/SecondaryButton";
import deleteDocApi from "../../api/database/deleteDocApi";
import updateDocApi from "../../api/database/updateDocApi";
import JSZip from "jszip";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import uploadFiles from "../../api/upload/uploadFiles";
import PrimaryButtonSexy from "../../buttons/PrimaryButtonSexy";
import SexySpin from "../../assets/SexySpinner";
import refreshFileUrl from "../../api/upload/refreshFileUrl";
import DropDownGPT03 from "../../dropdown/DropDownGTP03";
import DropDownGPTS3 from "../../dropdown/DropDownGPTS3";

interface FoldersProps {
  userData: User;
  orgData: Org;
  navigateWorkspace: (path: string) => void;
  setCanFetchFolders: (canFetch: boolean) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
}

function Xmls({
  userData,
  orgData,
  navigateWorkspace,
  setCanFetchFolders,
  handleClickVariant,
}: FoldersProps) {
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, fetchCarnets, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;
  const [searchValue, setSearchValue] = useState("");
  const [rows, setRows] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [options, setOptions] = useState<any>([]);
  const [year, setYear] = useState(null);
  const [loadingRows, setLoadingRows] = useState(true);
  const [new_open, setNewOpen] = useState(false);
  const [modifyXml, setModifyXml] = useState(false);
  const [updatedXml, setUpdatedXml] = useState<Xml | undefined>(undefined);
  const [newXml, setNewXml] = useState<Xml | undefined>(undefined);
  const [selected_ids, setSelectedIds] = useState<string[]>([]);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const handleSetSeachValue = (value: string) => {
    setSearchValue(value);
  };
  const [loadingData, setLoadingData] = useState(false);

  const years = [
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
  ];

  const [tag_folder_id, setTagFolderId] = useState(null);
  const [tag_index, setTagIndex] = useState(1);
  const [loadingXml, setLoadingXml] = useState<string>("");
  const [partners_options, setPartnersOptions] = useState<any>([]);
  // Function to navigate to a client by ID

  const gotoFolder = async (id: any) => {
    setLoadingXml(id.id);
    let updatedXml = (await getDocDataById("xml", id.id)) as Xml;
    if (updatedXml) {
      const token = await getOrRefreshFirebaseToken();
      let new_url = await refreshFileUrl(updatedXml.file?.id, token, prefix);
      await updateDocApi(
        "xml",
        updatedXml.id,
        {
          ...updatedXml,
          file: {
            ...updatedXml.file,
            url: new_url,
          },
        },
        prefix
      );

      updatedXml = (await getDocDataById("xml", id.id)) as Xml;
    }

    setUpdatedXml(updatedXml);
    setModifyXml(true);
    setLoadingXml("");
  };
  // Function to navigate to a client by name
  const gotoFolderName = (option: any) => {
    handleSearchChange(option.label);
    // Find the client with the matching name
  };

  const [update_search, setUpdateSearch] = useState(false);
  const handleSearchChange = async (name: string) => {
    handleSetSeachValue(name);
    setUpdateSearch(true);
  };

  const [tabs = [], setTabs] = useState<any>([]);

  const [allxmls, setAllXmls] = useState<Xml[]>([]);
  const tabContent = [<span></span>, <span></span>, <span></span>];
  const [particulier_folders, setParticulierFolders] = useState([]);

  const [masters, setMasters] = useState([]);
  const [only_folder_filter, setOnlyFolderFilter] = useState(
    folders_config?.only_folder_filter || null
  );

  const [activetab, setactivetab] = useState("recent");
  const [clients, setClients] = useState([]);
  const [partners, setPartners] = useState([]);

  const [searchCarnets, setsearchCarnets] = useState(
    folders_config?.search_folders || "folders"
  );
  const [tagFilterOpen, setTagFilterOpen] = useState(false);
  const [tag_filters, setTagFilters] = useState([]);

  const [users, setUsers] = useState([]);
  const [xml_hovered, setXmlHovered] = useState<boolean>(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [acceptedTypes, setAcceptedTypes] = useState([
    ".xml",
    "application/xml",
    "text/xml",
    "application/x-xml",
    "text/x-xml",
    "application/x-zip-compressed",
    "application/zip",
    "application/x-zip",
    "application/octet-stream",
  ]);

  const handleTabChange = async (newTab: any) => {
    let new_folders_config = folders_config || {};
    new_folders_config.tab = newTab;
    // set folders_config
    setAppState((prevState: any) => ({
      ...prevState,
      folders_config: new_folders_config,
    }));

    setactivetab(newTab);
  };

  const handleDragEnter = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  }, []);

  const handleDragOver = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  }, []);

  const handleDeleteSelectedAttestations = async () => {
    if (selected_ids.length === 0) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }
    setLoadingDelete(true);
    let refs = selected_ids.map((id) => getRefFromId("xml", id));
    if (refs.length > 0) {
      try {
        await Promise.all(
          refs
            .filter((ref) => ref !== null && ref !== undefined) // Filter out any null references
            .map((ref) => deleteDocApi(ref!, prefix))
        );
        handleClickVariant("Attestations supprimées avec succès", "success");
        setUpdatedXml(undefined);
        setSelectedIds([]);
        handleFetchData();
      } catch (error) {
        console.error("Error deleting attestations:", error);
        handleClickVariant(
          "Erreur lors de la suppression des attestations",
          "error"
        );
      }
    } else {
      handleClickVariant("Aucune attestation trouvée", "error");
    }
    setLoadingDelete(false);
  };
  const handleFilesDropped = async (files: any[]) => {
    if (loadingData) {
      handleClickVariant(
        "Un fichier est déjà en cours de chargement.",
        "error"
      );
      return;
    }

    // Process the first file (you can modify this to handle multiple files)
    const file = files[0];

    // Create a new XML document first
    setLoadingData(true);
    const newXmlDoc: Xml = {
      id: generateID("xml"),
      name: file.name.replace(/\.[^/.]+$/, ""), // Remove file extension
      org_id: orgData.id,
      creation_date: getFlutterTime(),
      last_updated: getFlutterTime(),
      rtb_compatible: true, // Default to true, can be set to false if XML is not compatible
      tags: [],
      attestations_id: [],
    };

    try {
      const isXml =
        file.name.toLowerCase().endsWith(".xml") ||
        file.type === "application/xml" ||
        file.type === "text/xml" ||
        file.type === "application/x-xml" ||
        file.type === "text/x-xml";

      let fileToProcess = file;
      let fileName = file.name;

      if (isXml) {
        console.log("Processing XML file:", file.name);
        newXmlDoc.rtb_compatible = false; // Set to false if the file is XML
        // Convert XML to ZIP
        const customFile: File = {
          url: URL.createObjectURL(file),
          name: file.name,
          id: `${prefix}${newXmlDoc.id}_file_${Date.now()}`,
          octets: file.size,
        };

        const zippedFile = await xmlToZip(customFile);

        // Create a new File object from the zipped result
        const response = await fetch(zippedFile.url);
        const blob = await response.blob();
        fileToProcess = new globalThis.File([blob], zippedFile.name, {
          type: "application/zip",
        });
        fileName = zippedFile.name;
      }

      // Process the file
      const reader = new FileReader();
      reader.onload = async (e) => {
        const newFile: File = {
          url: e.target?.result as string,
          name: fileName,
          id: `${prefix}${newXmlDoc.id}_file_${Date.now()}`,
          octets: fileToProcess.size,
        };

        await createDocApi("xml", newXmlDoc, prefix);

        const file_id = `orgs/${orgData.id}/xmls/${newXmlDoc.id}/file/${fileName}`;
        const token = await getOrRefreshFirebaseToken();

        const fresh_files = await uploadFiles(
          [newFile],
          file_id,
          "xml",
          token,
          prefix
        );

        if (fresh_files && fresh_files.files.length > 0) {
          const updatedDoc: Xml = {
            ...newXmlDoc,
            file: fresh_files.files[0],
            last_updated: getFlutterTime(),
            name: fileName.replace(/\.[^/.]+$/, ""),
          };

          await updateDocApi("xml", newXmlDoc.id, updatedDoc, prefix);
          handleFetchData();
          setLoadingData(false);
          handleClickVariant("Fichier uploadé avec succès", "success");
        }
      };

      // Read the actual File object, not a custom File type
      reader.readAsDataURL(fileToProcess);
    } catch (error) {
      console.error("Error processing dropped file:", error);
      handleClickVariant("Erreur lors du traitement du fichier.", "error");
      setLoadingData(false);
    }
  };

  const handleCreateAttestation = async () => {
    navigateWorkspace("/attestations?use_xml_id=" + updatedXml?.id);
  };

  const handleSaveAttestation = async (fresh_data: Xml | undefined) => {
    if (!updatedXml) {
      handleClickVariant("Aucun xml sélectionné", "error");
      return;
    }
    await updateDocApi(
      "xml",
      updatedXml.id,
      fresh_data ? fresh_data : updatedXml,
      prefix
    );
    handleClickVariant("Xml mise à jour avec succès", "success");

    handleFetchData();
  };

  const handleDeleteAttestation = async () => {
    if (!updatedXml) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }

    let ref = getRefFromId("xml", updatedXml?.id);
    if (ref) {
      await deleteDocApi(ref, prefix);
      await updateDocApi(
        "org",
        orgData.id,
        {
          ...orgData,
          counters: {
            ...orgData.counters,
            storage:
              (orgData.counters?.storage || 0) - (updatedXml.file?.octets || 0),
          },
        },
        prefix
      );
      handleClickVariant("Attestation supprimée avec succès", "success");
      setUpdatedXml(undefined);
      handleFetchData();
    } else {
      handleClickVariant(
        "Erreur lors de la suppression de l'attestation",
        "error"
      );
    }
    setModifyXml(false);
    handleFetchData();
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);

    // Filter files by accepted types
    const filteredFiles: any = files.filter((file) => {
      if (acceptedTypes.length === 0) return true;

      return acceptedTypes.some((type) => {
        if (type.startsWith(".")) {
          return file.name.toLowerCase().endsWith(type.toLowerCase());
        }
        return file.type === type;
      });
    });

    if (filteredFiles.length > 0) {
      // Process the dropped files
      handleFilesDropped(filteredFiles);
    }
  };
  const handleAddXml = async () => {
    if (loadingData) {
      handleClickVariant(
        "Un fichier est déjà en cours de chargement.",
        "error"
      );
      return;
    }

    const updatedXml: Xml = {
      id: generateID("xml"),
      name: "Nouveau xml",
      org_id: orgData.id,
      creation_date: getFlutterTime(),
      last_updated: getFlutterTime(),
      tags: [],
      attestations_id: [],
      rtb_compatible: true,
    };

    try {
      setNewXml(updatedXml);
      setNewOpen(true);
      handleFetchData();
    } catch (error) {
      console.error("Error creating attestation:", error);
      handleClickVariant(
        "Erreur lors de la création de l'attestation",
        "error"
      );
    }

    const input = document.createElement("input");
    input.type = "file";
    input.accept =
      "application/xml, text/xml, application/x-xml, text/x-xml, application/x-zip-compressed, application/zip, application/x-zip, application/octet-stream";

    input.onchange = async (event) => {
      const file = (event.target as HTMLInputElement).files?.[0];
      if (!file) return;

      try {
        setLoadingData(true);

        const isXml =
          file.name.toLowerCase().endsWith(".xml") ||
          file.type === "application/xml" ||
          file.type === "text/xml" ||
          file.type === "application/x-xml" ||
          file.type === "text/x-xml";

        let fileToProcess = file;
        let fileName = file.name;

        if (isXml) {
          updatedXml.rtb_compatible = false;
          // Convert XML to ZIP
          const customFile: File = {
            url: URL.createObjectURL(file),
            name: file.name,
            id: `${prefix}${updatedXml.id}_file_${Date.now()}`,
            octets: file.size,
          };

          const zippedFile = await xmlToZip(customFile);

          // Create a new File object from the zipped result
          const response = await fetch(zippedFile.url);
          const blob = await response.blob();
          fileToProcess = new globalThis.File([blob], zippedFile.name, {
            type: "application/zip",
          });
          fileName = zippedFile.name;
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
          if (!updatedXml) return;

          const newXml: File = {
            url: e.target?.result as string,
            name: fileName,
            id: `${prefix}${updatedXml.id}_file_${Date.now()}`,
            octets: fileToProcess.size,
          };

          const file_id = `orgs/${orgData.id}/xmls/${updatedXml.id}/file/${fileName}`;

          await createDocApi("xml", updatedXml, prefix);
          await updateDocApi(
            "org",
            orgData.id,
            {
              ...orgData,
              counters: {
                ...orgData.counters,
                xmls: (orgData.counters?.xmls || 0) + 1,
                storage: (orgData.counters?.storage || 0) + fileToProcess.size,
              },
            },
            prefix
          );

          const token = await getOrRefreshFirebaseToken();
          const fresh_files = await uploadFiles(
            [newXml],
            file_id,
            "xml",
            token,
            prefix
          );

          if (fresh_files?.files?.length) {
            const new_doc: Xml = {
              ...updatedXml,
              file: fresh_files.files[0],
              last_updated: getFlutterTime(),
              name: fileName.replace(/\.[^/.]+$/, ""),
            };

            await updateDocApi("xml", updatedXml.id, new_doc, prefix);
            handleFetchData();
          }

          setLoadingData(false);
        };

        // Read the actual File object, not a URL string
        reader.readAsDataURL(fileToProcess);
      } catch (error) {
        console.error("Error processing file:", error);
        handleClickVariant("Erreur lors du traitement du fichier.", "error");
        setLoadingData(false);
      }
    };

    input.click();
  };

  // Function to fetch data for the current user
  const handleFetchData = async () => {
    if (orgData) {
      // Fetch user data by currentUser's ID

      let filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      let xmls = (await queryCollection("xml", filters)) as Xml[];
      let partners = (await queryCollection(
        "partner",
        filters
      )) as MaitreOeuvre[];
      setPartnersOptions([
        {
          label: "Utiliser les données de l'opération",
          value: "use_operation_data",
        },
        ...partners.map((partner) => ({
          label: partner.name,
          value: partner.id,
        })),
      ]);
      // let carnets = await fetchCarnets(orgData);
      setAllXmls(xmls);
      setOptions(
        xmls.map((folder: Xml) => ({
          label: folder.name,
          value: folder.id,
        }))
      );

      setTabs([
        {
          label: "Récents",
          id: "recent",
        },

        {
          label: "Archivés",
          id: "archived",
        },
      ]);
      console.log("handleFetchData", xmls, orgData);
      if (updatedXml) {
        setUpdatedXml({
          ...updatedXml,
          partner_id:
            allxmls.find((xml: Xml) => xml.id === updatedXml.id)?.partner_id ||
            "use_operation_data",
        });
      }
      setTimeout(() => {
        setLoadingRows(false);
      }, 100);
      // Set options for the search bar (client names)
    }
  };

  useEffect(() => {
    if (orgData) {
      const { rows, columns } = transformXmlsToTable(
        allxmls,
        activetab,
        searchValue,
        partners_options
      );
      let sorted_rows = rows.sort((a: any, b: any) => {
        return a.name.trim().localeCompare(b.name.trim());
      });
      setRows(sorted_rows || []);
      setColumns(columns || []);
      setUpdateSearch(false);
    }
  }, [
    allxmls,
    orgData,
    userData,
    update_search,
    year,
    searchCarnets,
    searchValue,
    activetab,
  ]);

  const [loadingSelection, setLoadingSelection] = useState("");
  const handleDownload = async () => {
    if (!updatedXml) {
      handleClickVariant("Aucune attestation sélectionnée", "error");
      return;
    }

    if (!updatedXml.file || !updatedXml.file.url) {
      handleClickVariant("Aucun fichier associé à cette attestation", "error");
      return;
    }

    try {
      const response = await fetch(updatedXml.file.url);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = updatedXml.file.name || "fichier.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
      handleClickVariant("Erreur lors du téléchargement du fichier", "error");
    }
  };
  const handleSortChange = (sortModel: any) => {
    if (sortModel.length > 0) {
      const { field, sort } = sortModel[0]; // Get the field and sort direction
      let new_folders_config = folders_config || {};
      new_folders_config.field = field;
      new_folders_config.sort = sort;
      // set folders_config
      setAppState((prevState: any) => ({
        ...prevState,
        folders_config: new_folders_config,
      }));
      // You can add additional logic here, such as updating state or making an API call
    } else {
    }
  };

  useEffect(() => {
    if (orgData) {
      handleFetchData();
    }
  }, [orgData]);

  if (!userData || loadingRows) {
    return (
      <div className="h-full w-full pl-4 mr-4 flex flex-col items-center justify-center gap-2">
        <Spin />
      </div>
    );
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full w-full pl-4 pb-6 pr-4 max-h-full max-w-c1p4k overflow-auto">
      {loadingXml !== "" && (
        <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-50 z-50 flex items-center justify-center">
          <SexySpin></SexySpin>
        </div>
      )}
      {modifyXml && (
        <ModalRight
          isOpen={modifyXml}
          onClose={() => {
            setModifyXml(false);
            setUpdatedXml(undefined);
          }}
        >
          <div
            className="flex flex-col gap-4 p-4 w-c500
      
          "
          >
            <div className="text-h2 text-black">Modifier un xml</div>
            <div className="flex flex-col gap-2">
              <InfosBlockModify
                label="ID"
                value={updatedXml?.id || ""}
                onChange={(value: string) => {}}
                disabled={true}
              ></InfosBlockModify>
              <InfosBlockModify
                label="Nom"
                value={updatedXml?.name || ""}
                onChange={(value: string) => {
                  setUpdatedXml({
                    ...updatedXml!,
                    name: value,
                  });
                  handleSaveAttestation({
                    ...updatedXml!,
                    name: value,
                  });
                }}
              ></InfosBlockModify>{" "}
              <DropDownGPTS3
                value={updatedXml?.partner_id}
                items={partners_options}
                onChange={(value: any) => {
                  handleSaveAttestation({
                    ...updatedXml!,
                    partner_id: value.value,
                  });
                }}
                label="Partenaire"
              ></DropDownGPTS3>
              <div className="flex flex-row gap-2 justify-end w-full">
                <SecondaryButton
                  onClick={() => {
                    handleDeleteAttestation();
                  }}
                >
                  Supprimer
                </SecondaryButton>
              </div>
              {!updatedXml!.file ? (
                <div className="flex flex-col  justify-center items-center w-full hover:border-blue-400 border-1  bg-neutral-50 h-c50 rounded-lg overflow-hidden">
                  <Icon1 icon_name="file" size={20} fill="grey"></Icon1>
                </div>
              ) : (
                <div className="flex flex-row p-2 gap-3 items-center text-h3 w-full  border-1 bg-neutral-50 rounded-lg overflow-hidden">
                  <Icon1 icon_name="file" size={20} fill="grey"></Icon1>
                  <div className="flex flex-col mr-auto">
                    {updatedXml?.file ? (
                      <a
                        href={updatedXml.file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-blue-500  hover:underline"
                      >
                        {updatedXml?.file?.name}{" "}
                      </a>
                    ) : (
                      <span className="text-gray-500">Aucun file</span>
                    )}
                    <div className="text-gray-500 text-xs">
                      {updatedXml?.file?.octets
                        ? `(${(updatedXml.file.octets / 1024).toFixed(2)} Ko)`
                        : ""}
                    </div>
                  </div>
                  <div
                    className="cursor-pointer hover:text-red-500"
                    onClick={() => {
                      setUpdatedXml({
                        ...updatedXml!,
                        file: undefined,
                      });
                    }}
                  >
                    <Icon1 icon_name="delete" size={20} fill="grey"></Icon1>
                  </div>{" "}
                </div>
              )}
            </div>

            <div className="flex flex-row gap-2 justify-end w-full">
              <PrimaryButtonSexy
                onClick={() => {
                  handleCreateAttestation();
                }}
              >
                Générer attestation
              </PrimaryButtonSexy>

              <SecondaryButton
                onClick={() => {
                  handleDownload();
                }}
              >
                Télécharger
              </SecondaryButton>
            </div>
          </div>
        </ModalRight>
      )}

      <div className="flex flex-col w-full  gap-4 h-fit  ">
        <div className="flex flex-row gap-1 justify-between ">
          <div className="text-hx font-medium">Mes xml</div>
        </div>
        <div
          onMouseEnter={() => !isDragOver && setXmlHovered(true)}
          onMouseLeave={() => setXmlHovered(false)}
          onClick={handleAddXml}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          className={`rounded-2xl transition-all duration-500 ease-in-out cursor-pointer border-green-400 bg-gradient-to-tr to-black to-50% from-green-400 w-full justify-center items-center h-c100 border-1 bg-neutral-50 p-2 flex flex-col ${""}`}
          style={{
            height: xml_hovered || isDragOver ? "300px" : "100px",
          }}
        >
          <div className="absolute">
            <Icon1 icon_name="join" size={200} fill="rgba(255,255,255,0.12)" />
          </div>

          <div
            className={`flex
          ${
            xml_hovered || isDragOver
              ? "text-h1 text-wshadow_80 font-medium"
              : "text-h2 text-wshadow_75"
          }
          flex-row gap-4 items-center`}
          >
            {loadingData ? (
              <>
                <SexySpin></SexySpin>
              </>
            ) : (
              <>
                {isDragOver
                  ? "Relâchez pour déposer les fichiers"
                  : xml_hovered
                  ? "Cliquez pour sélectionner un fichier"
                  : "Déposez vos fichiers xml ici"}
                <Icon1
                  icon_name="join"
                  size={xml_hovered || isDragOver ? 25 : 20}
                  fill={
                    xml_hovered || isDragOver
                      ? "rgba(255,255,255,0.85)"
                      : "rgba(255,255,255,0.75)"
                  }
                />
              </>
            )}
          </div>
        </div>
        <div className="flex  gap-2 flex-row  2xl:justify-between h-fit">
          <BasicSearchBar
            onAction={() => {}}
            options={options}
            value={searchValue}
            setValue={handleSetSeachValue}
            placeholder="Rechercher un xml..."
          ></BasicSearchBar>
        </div>
        {searchValue === "" && (
          <div className="flex flex-row gap-2 h-fit">
            <div className="ml-0 pl-0 left-0 relative">
              <TabGPT
                tabs={tabs}
                activeTab={activetab}
                setActiveTab={handleTabChange}
              />
            </div>
          </div>
        )}
      </div>

      {selected_ids.length > 0 && (
        <div className="my-4">
          <PrimaryButton onClick={handleDeleteSelectedAttestations}>
            Supprimer les xml sélectionnés
            {loadingDelete && <SmallSpinner loading={true} />}
          </PrimaryButton>
        </div>
      )}

      <div className="w-full h-full max-h-[100%] max-w-full mt-2">
        <DataGridGPT2
          is_folders={true}
          selectable={true}
          rows={rows}
          columns={columns}
          searchValue={searchValue || ""}
          onClick={gotoFolder}
          initial_asc={"desc"}
          initial_sort_field="creation_date"
          handleSortChange={handleSortChange}
          initial_saved_columns_showed={{
            id: false,

            rdv: false,
          }}
          initialPage={0}
          initialPageSize={100}
          orgData={orgData}
          selected_ids={selected_ids}
          setSelectedIds={setSelectedIds}
        ></DataGridGPT2>
      </div>
    </div>
  );
}

export default Xmls;

export const xmlToZip = async (xmlFile: File): Promise<File> => {
  const zip = new JSZip();

  // Fetch the XML file content from the URL
  const response = await fetch(xmlFile.url);
  const xmlContent = await response.text();

  // Add the XML file to the zip
  zip.file(xmlFile.name, xmlContent);

  // Generate and return the zip blob
  let blob = await zip.generateAsync({ type: "blob" });
  // return a new File object with url, name, id and octets
  let new_file: File = {
    url: URL.createObjectURL(blob),
    name: xmlFile.name.replace(/\.[^/.]+$/, "") + ".zip",
    id: `${xmlFile.id}_zip_${Date.now()}`,
    octets: blob.size,
  };
  return new_file;
};
